module.exports = "<span class=\"icon -{{attachmentType}}\"></span>\n<div class=\"infos\">\n  <a href=\"{{ attachment.url }}\">{{ attachment.file }}</a>\n  <span>{{ attachment.size | bytesSize }}</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./ng2/shared/attachment-display/attachment-display.component.html
// module id = 1165
// module chunks = 0